var searchIcons = document.querySelectorAll(
  "#header-navigation .container .header-search"
);
searchIcons.length > 0 &&
  searchIcons.forEach((searchIcon) => {
    searchIcon.addEventListener("click", function () {
      var searchInput = document.querySelector(
        ".header-searchbar .search-field"
      );
      console.log(searchInput),
        searchInput &&
          setTimeout(function () {
            searchInput.click();
            searchInput.focus();
            var body = document.querySelector("body");
            var searchOverlay = document.querySelector(
              ".shopify-section-group-header-group .search-overlay"
            );
            if (body && !body.classList.contains("auto-complete-opened")) {
              body.classList.add("auto-complete-opened");
            }
          }, 300);
    });
  });
window.onWizzyScriptLoaded = function () {
  console.log("wizzy loaded====>");

  $("#wizzy-shopify-collection-page-wrapper").html("");
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      console.log("wizzy loaded");
      // $(".loaderSMSMSMS").css("display", "none");

      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers.push({
        dom: ".search-field",
        type: "text",
      });
      window.wizzyConfig.search.configs.general.searchEndpoint =
        "/pages/search-results-page";
      wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible = true;
      allCollectionRedirect();
      if (!window.wizzyConfig.common.isOnCategoryPage) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
          "#content"
        );
      }

      if (window.wizzyConfig.common.isOnCategoryPage) {
        window.wizzyConfig["search"]["configs"]["pagination"][
          "infiniteScrollOffset"
        ] = {
          desktop:
            $(".shopify-section-header").height() +
            $(".collection-desc-content-outer").height() +
            $(".custom-footer-main").height() +
            1500,
          mobile:
            $(".shopify-section-header").height() +
            $(".collection-desc-content-outer").height() +
            $(".custom-footer-main").height() +
            2000,
        };
      }

      if (screen.width < 768) {
        window.wizzyConfig.search.configs.facets.leftFacets.defaultCollapsed = true;
      }
      // window.sessionStorage.set("wizzyProductsArray")
      // window.sessionStorage.getItem("wizzyProductsArray")
      window.wizzyProductsArray = window.sessionStorage.getItem(
        "wizzyProductsArray"
      )
        ? JSON.parse(window.sessionStorage.getItem("wizzyProductsArray"))
        : [];
      // setTimeout(function () {
      //   $('.facet-search-wrapper').addClass('active');
      // }, 5000);
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      payload.attributeFacetValuesLimit = 50;

      if (screen.width < 768) {
        $(".wizzy-icon").click();
      } else {
        // $('.header-searchbar .search-form svg').click();
      }

      // window.Moengage.track_event("Product_Search", {
      //   "search_term": payload.q,
      // });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      payload.filters.attributeFacetValuesLimit = 50;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if (payload.api === "filter") {
        if (payload.response.payload.filters.page === 1) {
          window.sessionStorage.removeItem("wizzyProductsArray");
          window.wizzyProductsArray = [];
        }
      }

      if (payload.api === "search") {
        if (payload.response.payload.filters.page === 1) {
          window.sessionStorage.removeItem("wizzyProductsArray");
          window.wizzyProductsArray = [];
        }
      }
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;

        facets.forEach((facet) => {
          if (facet.key === "discountPercentage") {
            let maxDiscount = 0;

            facet.data.forEach((facetitem) => {
              if (facetitem.key > maxDiscount) {
                maxDiscount = facetitem.key;
              }
            });

            let discountArray = [10, 15, 30, 40, 50, 60];
            facetItem = [];
            discountArray.forEach((discount) => {
              if (discount <= maxDiscount) {
                facetItem.push({
                  data: {
                    start: discount,
                    label: discount,
                  },
                  key: discount,
                  label: `${discount}%`,
                });
              }
            });

            facet.data = facetItem;
          }
        });
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      console.log("payload", payload);
      $("#product_countTotal").text(payload.data.response.payload.total);
      if (payload.data?.response?.payload?.filters?.q) {
        $(".wizzy-search-query").html(
          `<strong>"${payload.data.response.payload.filters.q}"</strong>`
        );
      }
      // if(data.api=='search')
      // $('.header-searchbar .search-form').css('display','none');

      if (!$(".wizzy-selected-filters").text().trim()) {
        // $('.wizzy-search-filters-top').css('position', 'absolute')
      } else {
        $(".wizzy-search-filters-top").css("position", "static");
      }

      if (payload.data.api === "autocomplete") {
        renderStarsAutoComplete();

        if (screen.width > 768) {
          if ($("#shopify-section-header").offset().top > 42) {
            $(".wizzy-autocomplete-wrapper").addClass("strip-invisible");
          } else {
            $(".wizzy-autocomplete-wrapper").removeClass("strip-invisible");
          }
        } else {
          if ($("#shopify-section-header").offset().top > 42) {
            $(".wizzy-autocomplete-wrapper").addClass("strip-invisible");
          } else {
            $(".wizzy-autocomplete-wrapper").removeClass("strip-invisible");
          }
        }
      }
      return payload;
    }
  );

  function mobileSearchBack() {
    if (screen.width < 768) {
      $(".wizzy-search-back .wizzy-icon").click();
      $(".wizzy-autocomplete-wrapper").css("display", "none");
      $(".wizzy-search-form-wrapper").removeClass("mobileTapped");
    }
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      console.log("payload", payload);

      if (typeof isGwHelperLoaded !== "undefined") {
        const initIcon = new CustomEvent("ssw.faveicon.init");
        window.dispatchEvent(initIcon);
      }

      if ($(".wizzy-result-product").length === 1) {
        $(
          "body .wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-filters-top"
        ).css("position", "static");
      }
      if (window.location.href.split("/").includes("pages")) {
        $(".breadcrumb_text").css("display", "none");
        $(".container.grid.clearfix").css("display", "none");
      }
      setTimeout(function () {
        $(".wizzy-autocomplete-wrapper").css("display", "none");
      }, 500);
      // addToCart();
      //mobileSearchBack();
      searchPopupClose();
      removeClassFromMain();
      renderStars();

      dropdownCheck();

      if (userlogincheck == false) wishlistAttach();

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      //  Observer for Sort ****************************************************************************************************************************
      var observer1 = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
          if ($(".wizzy-common-select-options").css("display") === "block") {
            // alert("Inside Test")
            $("#wa-chat-btn-root").css("display", "none");
            $("#back-to-top").css("z-index", "-1");
          } else {
            $("#wa-chat-btn-root").css("display", "block");
            $("#back-to-top").css("z-index", "99999");
          }
        });
      });

      var target1 = document.getElementsByClassName(
        "wizzy-common-select-options"
      )[0];
      observer1.observe(target1, {
        attributes: true,
        attributeFilter: ["style"],
      });

      // **********************************************************************************************************************************************

      window.wizzyProductsArray = [
        ...window.wizzyProductsArray,
        ...window.wizzyConfig.pageStore.searchedResponse.result,
      ];
      try {
        window.sessionStorage.setItem(
          "wizzyProductsArray",
          JSON.stringify(window.wizzyProductsArray)
        );
        //$(".loaderSMSMSMS").css("display","none");
      } catch (e) {
        console.log("loaderSMSMSMS display catch", e);
        //$(".loaderSMSMSMS").css("display","none");
      }
      // $(".loaderSMSMSMS").css("display", "none");
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      try {
        payload.forEach((item) => {
          // console.log("item",item);

          if (item.price) {
            price = parseInt(item.price.replace(/,/g, ""), 10);
            item.price = price.toLocaleString();
            console.log(item.price);
          }
          if (item.sellingPrice) {
            sellingPrice = parseInt(item.sellingPrice.replace(/,/g, ""), 10);
            item.sellingPrice = sellingPrice.toLocaleString();
          }

          let foundVariant = item.attributes.filter(
            (varin) => varin.id == "product_variant_ids"
          );

          item.varientGroupId = item.groupId
            ? item.groupId
            : foundVariant[0].values[0].variationId;

          item.attributes.forEach((attr) => {
            if (attr.id === "product_rating_Reviews") {
              item.star = JSON.parse(attr.values[0].value[0]).value;
              [item.noOfFullStars, item.noOfHalfStars, item.noOfEmptyStars] =
                numberofStars(item.star);
              item.starMarkup = starMarkUp(
                item.noOfallCollectionRedirectFullStars,
                item.noOfHalfStars,
                item.noOfEmptyStars
              );
            }

            if (attr.id === "product_rating_count_Reviews") {
              item.reviewCount = attr.values[0].value[0];
            }
            if (attr.id === "product_variant_ids") {
              item.id = attr.values[0].value[0];
            }
            if (attr.id === "product_tags") {
              item.isOfferAvailable = isOfferAvailable(
                attr.values[0].value[0].split(",")
              );
            }

            if (attr.id === "product__collection_top_badge_custom") {
              item.collBadgeTop = attr.values[0].value[0];
            }

            if (attr.id === "product__collection_bottom_badge_custom") {
              item.collBadgeBottom = attr.values[0].value[0];
            }
          });
          if (
            window.location.href.split("/").includes("collections") &&
            !window.location.href.split("/").includes("products")
          ) {
            let p_url = item.url.split("/products");
            if (p_url.length >= 2) {
              item.url = window.location.host + "/products" + p_url[1];
            }
          }

          item.swatchGeneratorObject = item.hasSwatches
            ? JSON.stringify(
                item.swatches[0].values.map((val) => ({
                  value: val.value,
                  variationId: val.variationId,
                }))
              )
            : false;
        });
      } catch (error) {
        console.log(error);
      }

      // console.log(payload);
      return payload;
    }
  );

  const searchPopupClose = () => {
    $(".open-header.active").click();
  };

  function removeClassFromMain() {
    if (screen.width < 768) {
      $("#content").removeClass("index-page");
    }
  }

  function numberofStars(stars) {
    let noOfFullStars = 0;
    let noOfHalfStars = 0;
    let noOfEmptyStars = 5;

    noOfFullStars = parseInt(stars);
    if (stars - parseInt(stars)) {
      noOfHalfStars++;
    }
    noOfEmptyStars = 5 - noOfFullStars - noOfHalfStars;

    return [noOfFullStars, noOfHalfStars, noOfEmptyStars];
  }

  function starMarkUp(noOfFullStars, noOfHalfStars, noOfEmptyStars) {
    let fullString = ``;
    let halfString = ``;
    let emptyString = ``;

    for (let i = 0; i < noOfFullStars; i++) {
      fullString = fullString + `<span class="jdgm-star jdgm--on"></span>`;
    }

    for (let j = 0; j < noOfHalfStars; j++) {
      halfString = halfString + `<span class="jdgm-star jdgm--half"></span>`;
    }

    for (let k = 0; k < noOfEmptyStars; k++) {
      emptyString = emptyString + `<span class="jdgm-star jdgm--half"></span>`;
    }

    return fullString + halfString + emptyString;
  }

  function renderStars() {
    $(".wizzy-result-product").each(function (index, element) {
      if ($(element).find(".jdgm-prev-badge__stars").attr("starmarkup")) {
        $(element)
          .find(".jdgm-prev-badge__stars")
          .html($(element).find(".jdgm-prev-badge__stars").attr("starmarkup"));
      }
    });
  }

  function renderStarsAutoComplete() {
    $(".topproduct-item").each(function (index, element) {
      if ($(element).find(".jdgm-prev-badge__stars").attr("starmarkup")) {
        $(element)
          .find(".jdgm-prev-badge__stars")
          .html($(element).find(".jdgm-prev-badge__stars").attr("starmarkup"));
      }
    });
  }

  function isOfferAvailable(arr) {
    let isTrue = false;
    arr.forEach((item) => {
      if (item.trim() === "display_offers available") {
        isTrue = true;
      }
    });
    return isTrue;
  }

  function allCollectionRedirect() {
    const currentURL = window.location.href;
    if (currentURL.endsWith("/all")) {
      window.location.href = currentURL.replace("/all", "/all-products");
    }
  }
};

const mobileSearch = () => {
  $("body").on("click", ".search .open.open-header", function () {
    if (!$("body").hasClass("wizzyMobileTapped")) {
      $("#wizzy-search-input").click();
    }
  });
};
console.log("===================>");
// $("body").on("click", ".quick-view, .wizzy-tocart-button", function (evt) {
//     evt.preventDefault();
//     evt.stopImmediatePropagation(); // Stops propagation and prevents other handlers of the same event
// evt.stopImmediatePropagation();
//     console.log("===================>load file");

//     if (!$('script[src="https://nestasia.in/cdn/shop/t/356/assets/quickViewCustom.js?v=125857220327281854391725012047"]').length) {
//         var script = document.createElement('script');
//         script.src = "https://nestasia.in/cdn/shop/t/356/assets/quickViewCustom.js?v=125857220327281854391725012047";
//         script.async = true; // Load asynchronously to prevent blocking
//         document.head.appendChild(script); // Append to the head

//         script.onload = function () {
//             console.log("Script loaded successfully.");
//         };

//         script.onerror = function () {
//             console.error("Failed to load the script.");
//         };
//     } else {
//         console.log("Script already loaded.");
//     }

//     alert("===============>");
// });

mobileSearch();
